import React, { FC, PropsWithChildren } from 'react';

import { ModalStyles } from './ModalStyles';

import { Icons, IconsTypes } from '@/components/shared/Icons';

interface IModalProps {
  onClose: () => void;
  className?: string;
}

export const Modal: FC<PropsWithChildren<IModalProps>> = ({ children, onClose, className = '' }) => (
  <div className="fixed left-0 top-0 z-[51]  h-full w-full">
    <div className="absolute h-full w-full bg-black-900 opacity-40" onClick={onClose} />

    <div
      className={`relative left-1/2 top-1/2 z-40 max-h-[90vh] w-max -translate-x-1/2 -translate-y-1/2 rounded-lg bg-white ${className}`}
    >
      <button className="absolute -top-8 right-0 rounded-lg bg-white p-2" type="button" onClick={onClose}>
        {Icons({
          name: IconsTypes.CLOSE,
          iconProps: {
            className: 'text-black',
          },
        })}
      </button>
      {children}
    </div>
    <ModalStyles />
  </div>
);
